// Modules
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import type { RootState } from '../../types/store';
// Project
import AppActions from '../../actions/app-actions';
import AppConstants from '../../constants/app-constants';
import AppUtils from '../../utils/app-utils';
import UITimer from '../../components/ui-timer';
import UIHilight from '../../components/ui-hilight';
import UIBlurBox from '../../components/ui-blur-box';

export default function LobbyQuestion() {
    //const {setBG} = setCategoryBG() //From lobby-layout
    const dispatch = useDispatch();
    const lobby = useSelector((state: RootState) => state.page.lobby);
    const translate = useSelector((state: RootState) => state.ui.language);
    const categoryName = translate.categories.find(cat => cat.id === lobby.current_question.category);
    const theme = useTheme()

    useEffect(() => {
        AppUtils.vibrate(100);
        //dispatch(AppActions.GameResetAnswer({}));
    }, []);

    function onAnswer(value: number) {
        if (!lobby.playing) return;
        if (lobby.answer > 0) return;
        dispatch(AppActions.GameAnswer({ answer: value }));
    }
    function onToggleShowQuestion() {
        dispatch(AppActions.ShowQuestion({ show_question: !lobby.show_question }));
        //this.setState({ show_question: !this.state.showQuestion });
    }

    let question: React.JSX.Element = <></>;
    if (lobby.show_question) {
        question = (
            <UIBlurBox>
                <UIHilight
                    fontWeight={500}
                    variant={lobby.playing ? "h4" : "h3"}
                    align="center"
                    padding={{ xs: 1.5, md: 3 }}
                    sx={{
                        fontSize: lobby.playing
                            ? 'clamp(1.1rem, 2.5vw, 1.8rem)'
                            : 'clamp(1.5rem, 3.2vw, 2.8rem)',
                        lineHeight: 1.35,
                        wordBreak: 'break-word',
                    }}
                    text={lobby.current_question.question}
                />
            </UIBlurBox>
        );

    }
    let options: React.JSX.Element[] = [];
    lobby.current_question.options.forEach((v, i) => {
        let btnColor: string = theme.palette.primary.main;
        let canClick = true; // If the button is clickable
        let fontColor: string = "#ffff"
        if (lobby.answer > 0) {
            // By default, if the player has already answered, buttons are unclickable
            // and they are 'secondary'
            canClick = false;
            btnColor = theme.palette.grey[800];
            fontColor = theme.palette.grey[700];
            if (lobby.answer === v.id) {
                // Unless it is the one we've guessed
                btnColor = theme.palette.primary.main
                fontColor = "#ffff"
            }
        } else if (lobby.current_question.category === AppConstants.CATEGORY_MOST_LIKELY && lobby.nickname.toLowerCase() === v.value.toLowerCase()) {
            // If we are the answer (most likely), make it unclickable
            canClick = false;
            btnColor = theme.palette.grey[800];
            fontColor = theme.palette.grey[700];
        }

        options.push(
            <Grid key={i} size={{ xs: 12, md: 6, lg: 6 }} sx={{ marginTop: 3 }}>
                <Box bgcolor={btnColor} marginRight={2} marginLeft={2} padding={2} borderRadius={1} onClick={() => { if (canClick) { onAnswer(v.id) } }} style={{ userSelect: 'none' }}>
                    <Typography align='center' color={fontColor}>{v.value}</Typography>
                </Box>
            </Grid>
        );
    });

    if (lobby.playing) {
        let first = "";
        if (lobby.question <= 3) {
            first = lobby.show_question ? translate.lobby.question.pressTimerToHide : translate.lobby.question.pressTimerToShow;
        }
        return (
            <>
                <Grid
                    container
                    direction="column"
                    height="100%"
                    flexWrap="nowrap"
                    sx={{ flex: 1, overflow: 'hidden' }}
                >
                    <Box padding={1} flexShrink={0}>
                        <span onClick={onToggleShowQuestion}>
                            <UITimer seconds={lobby.timeleft} message={first} />
                        </span>
                    </Box>
                    <Box flexShrink={0}>
                        {question}
                    </Box>

                    <Grid
                        size={{ xs: 12, md: 12, lg: 12 }}
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        alignContent="center"
                        flexGrow={1}
                        sx={{
                            overflowY: 'auto',
                            paddingBottom: 2,
                            scrollbarWidth: 'none',
                            '&::-webkit-scrollbar': { display: 'none' }
                        }}
                    >
                        {options}
                    </Grid>
                </Grid>
            </>
        );
    }

    // We are hosting, show only question
    return (
        <Box
            height="100%"
            display="flex"
            flexDirection="column"
            flex={1}
            sx={{
                overflowY: 'auto',
                scrollbarWidth: 'thin',
                scrollbarColor: '#7dabd0ff rgba(255,255,255,0.1)',
                '&::-webkit-scrollbar': { width: '8px' },
                '&::-webkit-scrollbar-thumb': { background: '#7dabd0ff', borderRadius: '4px' },
                '&::-webkit-scrollbar-track': { background: 'rgba(255,255,255,0.1)' },
            }}
        >
            <Box flexShrink={0} padding={1}>
                <UITimer
                    seconds={lobby.timeleft}
                    styles={{ height: 80, parentWidth: "100%" }}
                    onClick={onToggleShowQuestion}
                    message={categoryName?.name?.toUpperCase()}
                />
            </Box>
            <Box
                flex={1}
                minHeight={0}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                px={{ xs: 2, md: 6 }}
                py={2}
                sx={{
                    maxWidth: 1200,
                    mx: 'auto',
                    width: '100%',
                }}
            >
                {question}
            </Box>
        </Box>
    );
}

